import { ApiTypes, getHostPathGenerator, headerFactory } from '~/networking';
import { ClientsideAuthentication } from '~/stores/ClientsideAuthentication';
import { getCurrencyCode } from '~/utils/localization';

export const getRequestUrl = getHostPathGenerator({ type: ApiTypes.Managed });

export function getAccessToken() {
    return ClientsideAuthentication.getInstance().jwt;
}

export const getHeaders = (secure?: boolean, extraHeaders?: { [key: string]: string } | Headers) => {
    return headerFactory({ secure, getAccessToken, getCurrencyCode, type: ApiTypes.Managed, headers: extraHeaders });
};
